import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const HeaderThree = () => {
  const [active, setActive] = useState(false);
  const [search, setSearch] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    let offCanvasNav = document.getElementById("offcanvas-navigation");
    let offCanvasNavSubMenu = offCanvasNav?.querySelectorAll(".sub-menu");

    if (offCanvasNavSubMenu) {
      for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
        offCanvasNavSubMenu[i].insertAdjacentHTML(
          "beforebegin",
          "<span class='mean-expand-class'>+</span>"
        );
      }
    }

    let menuExpand = offCanvasNav?.querySelectorAll(".mean-expand-class") || [];
    let numMenuExpand = menuExpand.length;

    function sideMenuExpand() {
      if (this.parentElement.classList.contains("active") === true) {
        this.parentElement.classList.remove("active");
      } else {
        for (let i = 0; i < numMenuExpand; i++) {
          menuExpand[i].parentElement.classList.remove("active");
        }
        this.parentElement.classList.add("active");
      }
    }

    for (let i = 0; i < numMenuExpand; i++) {
      if (menuExpand[i]) {
        menuExpand[i].addEventListener("click", sideMenuExpand);
      }
    }

    const handleScroll = () => {
      if (window.pageYOffset < 250) {
        setScroll(false);
      } else if (window.pageYOffset > 250) {
        setScroll(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const mobileMenu = () => {
    setActive(!active);
  };

  const searchControl = (active) => {
    setSearch(active);
  };

  const sidebarControl = (active) => {
    setSidebar(active);
  };

  return (
    <>
      <div
        className={`sidemenu-wrapper sidemenu-info ${sidebar ? "show" : ""} `}
      >
        <div className="sidemenu-content">
          <button
            className="closeButton sideMenuCls"
            onClick={() => sidebarControl(false)}
          >
            <i className="fas fa-times" />
          </button>
          <div className="widget  ">
            <div className="th-widget-about">
              <div className="about-logo">
                <Link to="/">
                  <img src="assets/img/logo.svg" alt="Grupo Rocvel" />
                </Link>
              </div>
              <p className="about-text">
                Desde 2023, o Grupo Rocvel desenvolve soluções estratégicas em recrutamento, hunting e fornecimento de mão de obra especializada em todo o território nacional.
              </p>
              <div className="social-links">
                <Link to="#">
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link to="#">
                  <i className="fab fa-twitter" />
                </Link>
                <Link to="#">
                  <i className="fab fa-linkedin-in" />
                </Link>
                <Link to="#">
                  <i className="fab fa-whatsapp" />
                </Link>
              </div>
            </div>
          </div>
          <div className="side-info mb-30">
            <div className="contact-list mb-20">
              <h4>Endereço do Escritório</h4>
              <p>Av. Paulista, 1636 Conjunto 05 | São Paulo - SP</p>
            </div>
            <div className="contact-list mb-20">
              <h4>Telefones</h4>
              <p className="mb-0">(11) 91525-9017</p>
              <p>(11) 91329-2398</p>
            </div>
            <div className="contact-list mb-20">
              <h4>E-mail Institucional</h4>
              <p className="mb-0">atendimento@gruporocvel.com.br</p>
              <p>comercial@gruporocvel.com.br</p>
            </div>
          </div>
          <ul className="side-instagram list-wrap">
            <li>
              <Link to="#">
                <img src="assets/img/gallery/1.jpg" alt="Estruturação de Equipes Rocvel" />
              </Link>
            </li>
            <li>
              <Link to="#">
                <img src="assets/img/gallery/2.jpg" alt="Gestão de RH Rocvel" />
              </Link>
            </li>
            <li>
              <Link to="#">
                <img src="assets/img/gallery/3.jpg" alt="Consultoria de Talentos Rocvel" />
              </Link>
            </li>
            <li>
              <Link to="#">
                <img src="assets/img/gallery/4.jpg" alt="Hunting Especializado Rocvel" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className={`popup-search-box ${search === true ? "show" : ""} `}>
        <button className="searchClose" onClick={() => searchControl(false)}>
          <i className="fas fa-times" />
        </button>
        <form>
          <input type="text" placeholder="O que você está procurando?" />
          <button type="submit">
            <i className="fas fa-search" />
          </button>
        </form>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu-wrapper ${active ? "body-visible" : ""}`}>
        <div className="mobile-menu-area">
          <div className="mobile-logo">
            <Link to="/">
              <img src="assets/img/logo.svg" alt="Grupo Rocvel" />
            </Link>
            <button className="menu-toggle" onClick={mobileMenu}>
              <i className="fa fa-times" />
            </button>
          </div>
          <div className="mobile-menu">
            <ul id="offcanvas-navigation">
              <li>
                <Link to="/">Início</Link>
              </li>
              <li>
                <Link to="/sobre-nos">Sobre Nós</Link>
              </li>
              <li>
                <Link to="/servicos">Serviços</Link>
              </li>
              <li>
                <a 
                  href="https://app.nobilivo.com/gruporocvel/vagas" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Área do Candidato
                </a>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/contato">Contato</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Header Area */}
      <header className="nav-header header-layout3">
        <div className="header-top d-none d-lg-block">
          <div className="container">
            <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
              <div className="col-auto">
                <div className="header-links">
                  <ul>
                    <li>
                      <i className="fas fa-envelope" />
                      <Link to="mailto:atendimento@gruporocvel.com.br">atendimento@gruporocvel.com.br</Link>
                    </li>
                    <li>
                      <i className="fas fa-envelope" />
                      <Link to="mailto:comercial@gruporocvel.com.br">comercial@gruporocvel.com.br</Link>
                    </li>
                    <li>
                      <i className="fas fa-phone-alt" />
                      <Link to="tel:+5511915259017">(11) 91525-9017</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-auto">
                <div className="header-links ps-0">
                  <ul>
                    <li>
                      <div className="social-links">
                        <Link to="https://www.facebook.com/share/1DUYht6Ytb/?mibextid=wwXIfr">
                          <i className="fab fa-facebook-f" />
                        </Link>
                        <Link to="https://www.instagram.com/grupo.rocvel/">
                          <i className="fab fa-instagram" />
                        </Link>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="header-top-bg-shape"></div>
        </div>
        <div className={`sticky-wrapper ${scroll ? "sticky" : ""}`}>
          {/* Main Menu Area */}
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-auto">
                <div className="header-logo">
                  <Link to="/">
                    <img src="assets/img/logo.svg" alt="Grupo Rocvel - Consultoria de RH" />
                  </Link>
                </div>
              </div>
              <div className="col-auto">
                <nav className="main-menu d-none d-lg-inline-block">
                  <ul>
                    <li>
                      <Link to="/">Início</Link>
                    </li>
                    <li>
                      <Link to="/sobre-nos">Sobre Nós</Link>
                    </li>
                    <li>
                      <Link to="/servicos">Serviços</Link>
                    </li>
                    <li>
                      <a 
                        href="https://app.nobilivo.com/gruporocvel/vagas" 
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        Área do Candidato
                      </a>
                    </li>
                    <li>
                      <Link to="/faq">FAQ</Link>
                    </li>
                    <li>
                      <Link to="/contato">Contato</Link>
                    </li>
                  </ul>
                </nav>
                <div className="navbar-right d-inline-flex d-lg-none">
                  <button
                    type="button"
                    className="menu-toggle icon-btn"
                    onClick={mobileMenu}
                  >
                    <i className="fas fa-bars" />
                  </button>
                </div>
              </div>
              <div className="col-auto ms-xxl-4 d-xl-block d-none">
                <div className="header-wrapper">
                  <div className="header-button">
                    <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações." className="global-btn style-border">
                      Fale com um Consultor
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderThree;